export var characterEntitiesLegacy = {
  AElig: 'Æ',
  AMP: '&',
  Aacute: 'Á',
  Acirc: 'Â',
  Agrave: 'À',
  Aring: 'Å',
  Atilde: 'Ã',
  Auml: 'Ä',
  COPY: '©',
  Ccedil: 'Ç',
  ETH: 'Ð',
  Eacute: 'É',
  Ecirc: 'Ê',
  Egrave: 'È',
  Euml: 'Ë',
  GT: '>',
  Iacute: 'Í',
  Icirc: 'Î',
  Igrave: 'Ì',
  Iuml: 'Ï',
  LT: '<',
  Ntilde: 'Ñ',
  Oacute: 'Ó',
  Ocirc: 'Ô',
  Ograve: 'Ò',
  Oslash: 'Ø',
  Otilde: 'Õ',
  Ouml: 'Ö',
  QUOT: '"',
  REG: '®',
  THORN: 'Þ',
  Uacute: 'Ú',
  Ucirc: 'Û',
  Ugrave: 'Ù',
  Uuml: 'Ü',
  Yacute: 'Ý',
  aacute: 'á',
  acirc: 'â',
  acute: '´',
  aelig: 'æ',
  agrave: 'à',
  amp: '&',
  aring: 'å',
  atilde: 'ã',
  auml: 'ä',
  brvbar: '¦',
  ccedil: 'ç',
  cedil: '¸',
  cent: '¢',
  copy: '©',
  curren: '¤',
  deg: '°',
  divide: '÷',
  eacute: 'é',
  ecirc: 'ê',
  egrave: 'è',
  eth: 'ð',
  euml: 'ë',
  frac12: '½',
  frac14: '¼',
  frac34: '¾',
  gt: '>',
  iacute: 'í',
  icirc: 'î',
  iexcl: '¡',
  igrave: 'ì',
  iquest: '¿',
  iuml: 'ï',
  laquo: '«',
  lt: '<',
  macr: '¯',
  micro: 'µ',
  middot: '·',
  nbsp: ' ',
  not: '¬',
  ntilde: 'ñ',
  oacute: 'ó',
  ocirc: 'ô',
  ograve: 'ò',
  ordf: 'ª',
  ordm: 'º',
  oslash: 'ø',
  otilde: 'õ',
  ouml: 'ö',
  para: '¶',
  plusmn: '±',
  pound: '£',
  quot: '"',
  raquo: '»',
  reg: '®',
  sect: '§',
  shy: '­',
  sup1: '¹',
  sup2: '²',
  sup3: '³',
  szlig: 'ß',
  thorn: 'þ',
  times: '×',
  uacute: 'ú',
  ucirc: 'û',
  ugrave: 'ù',
  uml: '¨',
  uuml: 'ü',
  yacute: 'ý',
  yen: '¥',
  yuml: 'ÿ'
}
